export default {
  channel: 'Channel {{count}}',
};
